var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tabs"},[_c('ul',_vm._l((_vm.itens),function(item,index){return _c('li',{key:index,staticClass:"ml-4",class:{'is-active': item.active}},[_c('a',{attrs:{"data-track":item.dataTrack},on:{"click":item.clickTab}},[_c('span',[_vm._v(_vm._s(item.label))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }